import React, { FC, useEffect } from "react";
import { Flex, Image, Text } from "rebass";
import styled from "styled-components";
import { IGetPatientPhotoInput, IGetPatientPhotoOutput, IGetProviderPatientByIdOutput } from "../../graphql/types/queries/patient";
import { Skeleton } from '../../components/loadingSkeleton/Skeleton'
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_PATIENT_PHOTO } from "../../graphql/queries";
import { VISIT_PAGE_CONSTANTS } from "./constants";
import moment from "moment";

const TopBarVisitWrapper = styled(Flex)`
  height: 140px;
  align-items: center;
`
interface IProps {
  data: IGetProviderPatientByIdOutput | undefined,
  loading: boolean
}

const Photo: FC<IProps> = ({
  loading,
  data
}) => {
  const [fetchPhoto, { data: dataPhoto, loading: loadingPhoto }] = useLazyQuery<IGetPatientPhotoOutput, IGetPatientPhotoInput>(GET_PATIENT_PHOTO)

  useEffect(() => {
    if (data && data.getProviderPatientById) {
      fetchPhoto({
        variables: {
          id: data.getProviderPatientById.athenaId
        }
      })
    }
  }, [loading, data])

  return (
    <Flex justifyContent={'center'} alignItems='center' width='150px' style={{ marginRight: VISIT_PAGE_CONSTANTS.COLUMN_SEPARATOR_WIDTH }}>
      {!!loading || !!loadingPhoto || !dataPhoto ? (
        <Flex width={96} height={96} style={{ borderRadius: '50%', border: '4px solid #7992B3', overflow: 'hidden' }}>
          <Skeleton width={96} height={96} style={{ borderRadius: '50%' }} />
        </Flex>
      ) : (
        <Image width={96} height={96} style={{ borderRadius: '50%', border: '4px solid #7992B3', objectFit: 'cover' }} src={`data:image/png;base64, ${dataPhoto?.getPatientPhoto}`} />
      )}
    </Flex>
  )
}

const Identifier: FC<IProps> = ({ loading, data }) => {
  return (
    <Flex flexDirection={'column'}>
      {!!loading ? (
        <Flex>
          <Skeleton width={240} height={43} style={{marginRight: 20}}/>
          <Skeleton width={80} height={30} style={{marginRight: 20}}/>
        </Flex>
      ) :
        <Flex>
        <Text style={{fontFamily: 'Playfair Display Bold', fontWeight:700, fontSize: 32}}>{`${data?.getProviderPatientById?.firstname} ${data?.getProviderPatientById?.lastname}`}</Text>
        {/* <Text>{data?.getProviderPatientById.}</Text> */}
        </Flex>}
        {!!loading ? (
        <Flex>
          <Skeleton width={56} height={24} style={{marginRight: 6}}/>
          <Text fontWeight={300} marginRight={'20px'}>ID</Text>
          <Skeleton width={32} height={24} style={{marginRight: 6}}/>
          <Text fontWeight={300} marginRight={'20px'}>years old</Text>
        </Flex>
      ) :
        <Flex alignItems={'baseline'}>
          <Text fontWeight={500} fontSize='24px' marginRight={'6px'}>{data?.getProviderPatientById?.athenaId}</Text>
          <Text fontWeight={300} fontSize='14px' marginRight={'20px'}>ID</Text>
          <Text fontWeight={500} fontSize='24px' marginRight={'6px'}>{data?.getProviderPatientById?.dob?moment(data?.getProviderPatientById?.dob).diff(moment(), 'y')*-1:''}</Text>
          <Text fontWeight={300} fontSize='14px' marginRight={'20px'}>years old</Text>
        </Flex>}
    </Flex>
  )
}
export const TopBarVisit: FC<IProps> = ({
  data,
  loading
}) => {
  return (
    <TopBarVisitWrapper>
      <Photo data={data} loading={loading} />
      <Identifier data={data} loading={loading} />
    </TopBarVisitWrapper>
  )
}